// @flow

import Service from './service';
import type { HttpResponseType } from '../types/http-response';

export default class SmsService extends Service {
  send(url: string, payload: Object): Promise<Object> {
    if (typeof url !== 'string' || typeof payload !== 'object') {
      return Promise.reject('Invalid arguments');
    }

    return this.api.post(`${this.baseUrl}/${url}`, payload)
      .then((res: HttpResponseType) => (res.data));
  }
}
